module.exports = __webpack_public_path__ + "img/bridge-width-2.904dfd6.svg?v=1761300065174";